import React from 'react';

export default function HorizontalCard(props) {
    return(
        <React.Fragment>
            <div className="card mb-3 hcard">
                <div className="row no-gutters">
                    <div className="col-md-4">
                        <img src={props.img} alt="" className="card-img"/>
                    </div>
                    <div className="col-sm">
                        <div className="card-body">
                            <h5 className="card-title">{props.title}</h5>
                            <p className="card-text">
                                <small>{props.desc}</small></p>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}